import React from "react"
import tw, { css, styled } from "twin.macro"
import Link from "next/link"

export enum TooltipPosition {
  Bottom = "Bottom",
  Left = "Left",
  Right = "Right",
}
interface StyleProp {
  position?: string
  tooltipLeft?: number
}
const TooltipText = styled.span(({ position, tooltipLeft }: StyleProp) => [
  tw`opacity-0 transition-opacity duration-300 invisible absolute w-[160px] p-2 bg-base-2 rounded text-xs text-base-5 z-10`,
  css`
    left: ${tooltipLeft ?? 0}px;
  `,
  position === TooltipPosition.Bottom &&
    tw`top-7 before:(absolute -top-2 left-[45%] border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 border-b-base-2)`,
  position === TooltipPosition.Right &&
    tw`-top-2 left-7 before:(absolute -left-2 border-t-8 border-t-transparent border-b-8 border-b-transparent border-r-8 border-r-base-2)`,
  position === TooltipPosition.Left &&
    tw`-top-2 -left-44 before:(absolute left-40 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-base-2)`,
])

interface TooltipProps {
  text: string | JSX.Element
  tooltipText: string
  href?: string
}
export const Tooltip = ({ text, tooltipText, tooltipLeft, href, position }: TooltipProps & StyleProp) => {
  return (
    <span
      tw="relative cursor-pointer"
      css={`
        &:hover span {
          opacity: 100;
          visibility: visible;
        }
      `}
    >
      {!!href ? (
        <Link href={href} passHref>
          <a>{text}</a>
        </Link>
      ) : (
        <>{text}</>
      )}
      <TooltipText position={!!position ? position : TooltipPosition.Bottom} tooltipLeft={tooltipLeft}>
        {tooltipText}
      </TooltipText>
    </span>
  )
}
